import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Privacidad from "../pages/Privacidad";
import Terminos from "../pages/Terminos";
import Cookies from "../pages/Cookies";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacidad",
    element: <Privacidad />,
  },
  {
    path: "/terminos",
    element: <Terminos />,
  },
  {
    path: "/cookies",
    element: <Cookies />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
